const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';
const HARAKAT_RE = /[\u064B-\u065F\u0670]/;
const ARABIC_LETTER_RE = /[\u0621-\u064A]/;

function getLastArabicLetter(value) {
  const chars = Array.from(value || '');
  for (let i = chars.length - 1; i >= 0; i -= 1) {
    if (ARABIC_LETTER_RE.test(chars[i])) return chars[i];
  }
  return null;
}

function replaceLastVowelWith(value, vowel) {
  if (!value) return value;

  const chars = Array.from(value);
  let lastLetterIndex = -1;

  for (let i = chars.length - 1; i >= 0; i -= 1) {
    if (ARABIC_LETTER_RE.test(chars[i])) {
      lastLetterIndex = i;
      break;
    }
  }

  if (lastLetterIndex === -1) return value;

  let result = '';
  for (let i = 0; i < chars.length; i += 1) {
    if (i <= lastLetterIndex) {
      result += chars[i];
    } else if (!HARAKAT_RE.test(chars[i])) {
      result += chars[i];
    }
  }

  return result + vowel;
}

function addFemininePluralNun(prefix, verb3ms) {
  const lastLetter = getLastArabicLetter(verb3ms);
  if (lastLetter === 'ن') {
    return prefix + replaceLastVowelWith(verb3ms, SHADDA + FATHA);
  }
  return prefix + replaceLastVowelWith(verb3ms, SUKUN) + 'نَ';
}

export function conjugatePresentWithFathaPrefixesFromPast(verb3ms) {
  if (!verb3ms) return null;

  const anaPrefix = 'أ' + FATHA;
  const taPrefix = 'ت' + FATHA;
  const yaPrefix = 'ي' + FATHA;
  const naPrefix = 'ن' + FATHA;
  const dammaStem = replaceLastVowelWith(verb3ms, DAMMA);
  const kasraStem = replaceLastVowelWith(verb3ms, KASRA);

  return {
    'أَنَا': anaPrefix + dammaStem,
    'أَنْتَ': taPrefix + dammaStem,
    'أَنْتِ': taPrefix + kasraStem + 'ينَ',
    'هُوَ': yaPrefix + dammaStem,
    'هِيَ': taPrefix + dammaStem,
    'نَحْنُ': naPrefix + dammaStem,
    'أَنْتُمْ': taPrefix + dammaStem + 'ونَ',
    'أَنْتُنَّ': addFemininePluralNun(taPrefix, verb3ms),
    'هُمْ': yaPrefix + dammaStem + 'ونَ',
    'هُنَّ': addFemininePluralNun(yaPrefix, verb3ms),
  };
}
